import type { Locale } from './locale';

export type SplashChromeCopy = {
    nav: {
        home: string;
        features: string;
        contact: string;
        startFreeDemo: string;
        signIn: string;
        toggleMenu: string;
    };
    footer: {
        mainOffice: string;
        inquiries: string;
        inquiriesPrompt: string;
    };
};

const en: SplashChromeCopy = {
    nav: {
        home: 'Home',
        features: 'Features',
        contact: 'Contact Us',
        startFreeDemo: 'Start Free Demo',
        signIn: 'Sign In',
        toggleMenu: 'Toggle navigation menu',
    },
    footer: {
        mainOffice: 'Main Office',
        inquiries: 'Inquiries',
        inquiriesPrompt: 'For inquiries or questions please call:',
    },
};

const es: SplashChromeCopy = {
    nav: {
        home: 'Inicio',
        features: 'Funciones',
        contact: 'Contáctenos',
        startFreeDemo: 'Iniciar demo gratis',
        signIn: 'Iniciar sesión',
        toggleMenu: 'Abrir o cerrar el menú de navegación',
    },
    footer: {
        mainOffice: 'Oficina principal',
        inquiries: 'Consultas',
        inquiriesPrompt: 'Para consultas o preguntas, llame al:',
    },
};

export function getSplashChromeCopy(locale: Locale): SplashChromeCopy {
    return locale === 'es' ? es : en;
}
